import styles from "./Navdots.module.css";

export const Navdots = ({content, image, setImage, setUserInteracted}) => {
  return (
    <>
      {content.map((slide, index) => {
        return (
          <span
            className={`${index === image ? styles.dotSelected : styles.dot}`}
            key={slide.name}
            name={slide.name}
            onClick={() => {
              setImage(index);
              setUserInteracted(true);
            }}></span>
        );
      })}
    </>
  );
};
